import { styled } from '@grupoboticario/flora'
import { Box, IconButton } from '@grupoboticario/flora-react'

export const StepperDot = styled('span', {
  background: '$disabledBackground',
  borderRadius: '$large',
  display: 'block',
  height: '$3',
  width: '$3',
  margin: '0 $1',
  transition: 'all 0.3s ease-in-out',
  variants: {
    active: {
      true: {
        background: '$backgroundAltPrimary',
        width: 24,
      },
    },
  },
})

export const StepperNav = styled(Box, {
  minWidth: 32,
})

export const StepperIconButton = styled(IconButton, {
  height: 32,
  width: 32,
})
